import { render } from 'preact';

class InitWidget {
  element: HTMLElement;

  widgetName: string;

  constructor(element: HTMLElement, module: string) {
    this.element = element;
    this.widgetName = module;

    this.init();
  }

  init() {
    import((`./${this.widgetName}/index.ts`)).then(({ default: WidgetComponent }) => {
      render((<WidgetComponent dataset={this.element.dataset} />), this.element);
      window.dispatchEvent(
        new CustomEvent(
          'widget.loaded',
          {
            detail: {
              element: this.element,
              widget: this.widgetName,
            },
          },
        ),
      );
    });
  }
}

export default InitWidget;
